// customModal.js - Global Event Dispatcher for Custom Website Modal

export function openCustomWebsiteModal(category = '', template = '') {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('oz:open-custom-website-modal', { detail: { category, template } }));
  }
}
